import { ReactNode, Suspense, lazy } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, Outlet } from 'react-router';

import { LoadingScreen } from '@zeta-core';

import { CompactErrorPage } from '../../layouts/compact-layout';
const ClientLoginPage = lazy(() => import('../../pages/auth/login-client'));
const ClientVerificationPage = lazy(() => import('../../pages/auth/verification-client'));
const ForgotPasswordPage = lazy(() => import('../../pages/auth/forgot-password'));
const ResetPasswordPage = lazy(() => import('../../pages/auth/forgot-password/reset-password'));
const LoginLayout = ({ children }: { children: ReactNode }) => children;

const AuthRoutes = [
  {
    path: 'auth',
    children: [
      {
        path: '',
        element: (
          <ErrorBoundary FallbackComponent={CompactErrorPage}>
            <LoginLayout>
              <Suspense fallback={<LoadingScreen />}>
                <Outlet />
              </Suspense>
            </LoginLayout>
          </ErrorBoundary>
        ),
        children: [
          {
            path: 'login',
            element: <ClientLoginPage />,
          },
          {
            path: 'verification',
            element: <ClientVerificationPage />,
          },
          {
            path: 'forgot-password',
            element: <ForgotPasswordPage />,
          },
          {
            path: 'reset-password',
            element: <ResetPasswordPage />,
          },
          {
            path: '',
            element: <Navigate to="login" replace />,
          },
        ],
      },
    ],
  },
];

export default AuthRoutes;
